
import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';
import { Waves } from 'lucide-react';

interface BeachFilterProps {
  value: boolean | null;
  onChange: (value: boolean | null) => void;
}

export const BeachFilter = ({ value, onChange }: BeachFilterProps) => {
  return (
    <div className="space-y-3">
      <Label className="text-sm font-medium block">Beach Destinations</Label>
      <div className="rounded-lg border border-blue-100 bg-blue-50/50 p-3 hover:bg-blue-50 transition-colors">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2.5">
            <div className="rounded-full bg-blue-100 p-1.5">
              <Waves className="w-4 h-4 text-blue-600" />
            </div>
            <span className="text-sm text-gray-700">Show only beach destinations</span>
          </div>
          <Switch
            checked={value === true}
            onCheckedChange={(checked) => onChange(checked ? true : null)}
            className="data-[state=checked]:bg-blue-600"
          />
        </div>
      </div>
    </div>
  );
};
